import React, { useEffect, useState } from "react";
import { NavLink } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import RingBuilder from "../../assets/images/JC_Icon_RingBuilder_small.png";
import DiamondLink from "../../assets/images/JC_Icon_DiamondLink_small.png";
import PendantBuilder from "../../assets/images/JC_Icon_PendantBuilder_small.png";
import StudBuilder from "../../assets/images/JC_Icon_StudBuilder_small.png";
import JewelryLink from "../../assets/images/Jc_Icon_JewelryLink_small.png";
import Watchcustomizer from "../../assets/images/JC_Icon_WatchCustomizer_small.png";
import Data from "../../assets/images/Data.png";
import WebsiteSync from "../../assets/images/Website-Sync.png";
import { useTranslation } from "react-i18next";
import {
  setChecklinkHeaderMenuData,
  setOpenKeyHeaderMenuData,
  setSelectSideMenu,
} from "../../actions/headerMenu/headerMenu";
import MasterLink from "../../assets/images/JC_Icon_MasterLink_small.png";

const AllApps = () => {
  const { t } = useTranslation();
  const [applicationPermisstionResponse, setApplicationPermisstionResponse] =
    useState({});
  const headerDetials = useSelector((state) => state.headerMenuReducer);
  const dispatch = useDispatch();
  useEffect(() => {
    if (headerDetials) {
      if (headerDetials.applicationPermisstionResponse) {
        setApplicationPermisstionResponse(
          headerDetials.applicationPermisstionResponse
        );
      }
    }
  }, []);
  const handleOpenSideMenu = (Menu) => {
    var MenuData = [`${Menu}`];

    dispatch(setOpenKeyHeaderMenuData(MenuData));
    if (Menu == "Diamond Link") {
      dispatch(setSelectSideMenu(["applicationPreviewDiamondLink"]));
    }
    if (Menu == "Ring Builder") {
      dispatch(setSelectSideMenu(["applicationPreviewRingBuilder"]));
    }
    if (Menu == "Stud Builder") {
      dispatch(setSelectSideMenu(["applicationPreviewStudBuilder"]));
    }
    if (Menu == "Pendant Builder") {
      dispatch(setSelectSideMenu(["applicationPreviewPedantBuilder"]));
    }

    if ((Menu = "Website Sync")) {
      dispatch(setChecklinkHeaderMenuData("My Catalog"));
      dispatch(setSelectSideMenu(["SyncHistory"]));
    }
  };
  return (
    <React.Fragment>
      <div className="form__fields magento__mapping allapps__section p-5">
        <div className="row m-5">
          <div className={"col-md-3 offset-1"}>
            <div className="apps__block">
              <NavLink
                to={
                  applicationPermisstionResponse.diamondLink == false
                    ? "#"
                    : "/applicationPreviewDiamondLink"
                }
                onClick={
                  applicationPermisstionResponse.diamondLink == false
                    ? (e) => e.preventDefault()
                    : () => handleOpenSideMenu("Diamond Link")
                }
                style={{ display: "inline-block" }}
              >
                <img
                  src={DiamondLink}
                  width="150"
                  className={
                    applicationPermisstionResponse.diamondLink == false
                      ? "any-disable"
                      : "app-image"
                  }
                  style={{
                    cursor:
                      applicationPermisstionResponse.diamondLink == false
                        ? "not-allowed"
                        : "pointer",
                  }}
                />
              </NavLink>
            </div>
          </div>

          <div className={"col-md-3 "}>
            <div className="apps__block">
              <NavLink
                title={
                  applicationPermisstionResponse.ringBuilder == false
                    ? "Ring Builder Not Access"
                    : "Ring Builder"
                }
                to={
                  applicationPermisstionResponse.ringBuilder == false
                    ? "#"
                    : "/applicationPreviewRingBuilder"
                }
                onClick={
                  applicationPermisstionResponse.ringBuilder == false
                    ? (e) => e.preventDefault()
                    : () => handleOpenSideMenu("Ring Builder")
                }
                style={{ display: "inline-block" }}
              >
                <img
                  src={RingBuilder}
                  width="150"
                  className={
                    applicationPermisstionResponse.ringBuilder == false
                      ? "any-disable"
                      : "app-image"
                  }
                  style={{
                    cursor:
                      applicationPermisstionResponse.ringBuilder == false
                        ? "not-allowed"
                        : "pointer",
                  }}
                />
              </NavLink>
            </div>
          </div>

          <div className={"col-md-3 "}>
            <div className="apps__block">
              <NavLink
                title={
                  applicationPermisstionResponse.pendantBuilder == false
                    ? "Pendant Builder Not Access"
                    : "Pendant Builder"
                }
                to={
                  applicationPermisstionResponse.pendantBuilder == false
                    ? "#"
                    : "/applicationPreviewPedantBuilder"
                }
                onClick={
                  applicationPermisstionResponse.pendantBuilder == false
                    ? (e) => e.preventDefault()
                    : () => handleOpenSideMenu("Pendant Builder")
                }
                style={{ display: "inline-block" }}
              >
                <img
                  src={PendantBuilder}
                  width="150"
                  className={
                    applicationPermisstionResponse.pendantBuilder == false
                      ? "any-disable"
                      : "app-image"
                  }
                  style={{
                    cursor:
                      applicationPermisstionResponse.pendantBuilder == false
                        ? "not-allowed"
                        : "pointer",
                  }}
                />
              </NavLink>
            </div>
          </div>
        </div>
        <div className="row m-5">
          <div className={"col-md-3 offset-1 "}>
            <div className="apps__block">
              <NavLink
                to={
                  applicationPermisstionResponse.studBuilder == false
                    ? "#"
                    : "/applicationPreviewStudBuilder"
                }
                onClick={
                  applicationPermisstionResponse.studBuilder == false
                    ? (e) => e.preventDefault()
                    : () => handleOpenSideMenu("Stud Builder")
                }
                style={{ display: "inline-block" }}
              >
                <img
                  src={StudBuilder}
                  width="150"
                  className={
                    applicationPermisstionResponse.studBuilder == false
                      ? "any-disable"
                      : "app-image"
                  }
                  style={{
                    cursor:
                      applicationPermisstionResponse.studBuilder == false
                        ? "not-allowed"
                        : "pointer",
                  }}
                />
              </NavLink>
            </div>
          </div>

          <div className={"col-md-3"}>
            <div className="apps__block">
              <NavLink
                title={
                  applicationPermisstionResponse.masterLink == false
                    ? "Master Link Not Access"
                    : "Master Link"
                }
                to={
                  applicationPermisstionResponse.masterLink == false
                    ? "#"
                    : "/MasterLinkApplicationPreview"
                }
                onClick={
                  applicationPermisstionResponse.masterLink == false
                    ? (e) => e.preventDefault()
                    : () => handleOpenSideMenu("Master Link")
                }
                style={{ display: "inline-block" }}
              >
                <img
                  src={MasterLink}
                  width="150"
                  className={
                    applicationPermisstionResponse.masterLink == false
                      ? "any-disable"
                      : "app-image"
                  }
                  style={{
                    cursor:
                      applicationPermisstionResponse.masterLink == false
                        ? "not-allowed"
                        : "pointer",
                  }}
                />
              </NavLink>
            </div>
          </div>

          <div className={"col-md-3"}>
            <div className="apps__block">
              <NavLink
                title={
                  applicationPermisstionResponse.jewelryLink == false
                    ? "Jewelry Link Not Access"
                    : "Jewelry Link"
                }
                to={
                  applicationPermisstionResponse.jewelryLink == false
                    ? "#"
                    : "/myvendors"
                }
                onClick={
                  applicationPermisstionResponse.jewelryLink == false
                    ? (e) => e.preventDefault()
                    : () => handleOpenSideMenu("Jewelry Link")
                }
                style={{ display: "inline-block" }}
              >
                <img
                  alt="jewelryLink"
                  src={JewelryLink}
                  width="150"
                  className={
                    applicationPermisstionResponse.jewelryLink == false
                      ? "any-disable"
                      : "app-image"
                  }
                  style={{
                    cursor:
                      applicationPermisstionResponse.jewelryLink == false
                        ? "not-allowed"
                        : "pointer",
                  }}
                />
              </NavLink>
            </div>
          </div>
        </div>
      </div>
    </React.Fragment>
  );
};

export default AllApps;
